import { cdnImage, CDNImageProps } from '@/utils/image-utils';
import { envIsCanada, envIsSweden } from '@/constants/constants';
import React from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import LinearGradient from '@/components/shared/gradient/LinearGradient';
import {
  selectHeroBackgrounds,
  selectHeroBackgroundsLoading,
} from '@/store/cms/hero-backgrounds/selectors';
import LoadingSpinner from '@/components/shared/spinner/LoadingSpinner';

const desktopProps: CDNImageProps = { width: '1920', height: '900', fit: 'crop' };
const tabletProps: CDNImageProps = { width: '960', height: '900', fit: 'crop' };
const mobileProps: CDNImageProps = { width: '640', height: '900', fit: 'crop', gravity: 'right' };

const HeroLayout = ({
  children,
  isAuthenticated,
  fullHeight = false,
}: {
  children: React.ReactNode;
  isAuthenticated: boolean;
  fullHeight?: boolean;
}): JSX.Element => {
  const heroBackgrounds = useSelector(selectHeroBackgrounds);
  const heroBackgroundsLoading = useSelector(selectHeroBackgroundsLoading);

  const backgrounds = isAuthenticated
    ? heroBackgrounds.authenticated
    : heroBackgrounds.unauthenticated;

  return (
    <div
      className={classNames(
        'relative bg-blue-medium flex flex-col items-center ',
        !envIsCanada() ? 'justify-center' : '',
        envIsCanada()
          ? ''
          : envIsSweden()
          ? 'min-h-heroMobileHeightSweden'
          : 'min-h-heroMobileHeight',
        { 'min-h-screen': fullHeight },
      )}
    >
      <div className="absolute left-0 right-0 bottom-0 top-0 after:absolute after:right-0 after:left-0 after:bottom-0 after:top-0 z-0">
        <LinearGradient
          from="rgba(0, 0, 0, 0.3)"
          to="rgba(0, 0, 0, 0.75)"
          direction="bottom"
          transitionPoint="60%"
        />

        {heroBackgroundsLoading ? (
          <div className="w-screen h-screen flex items-center justify-center">
            <LoadingSpinner />
          </div>
        ) : (
          <picture className="w-full h-full object-cover object-center">
            <source
              media="(max-width: 640px)"
              srcSet={cdnImage(backgrounds.mobile ?? 'luckydays-beach.jpg', mobileProps)}
            />
            <source
              media="(max-width: 960px)"
              srcSet={cdnImage(backgrounds.tablet ?? 'luckydays-beach.jpg', tabletProps)}
            />
            <img
              className="object-cover object-center w-full h-full"
              src={cdnImage(backgrounds.desktop ?? 'luckydays-beach.jpg', desktopProps)}
              alt="Lucky the cat on his way to the beach"
            />
          </picture>
        )}
      </div>
      {children}
    </div>
  );
};

export default HeroLayout;
